export enum DieEventValues {
  rollBegin,
  collision,
  rollComplete, // _technically_ when a die settles
  minRoll,
  maxRoll,
  dieRemoved, // _technically_ when a die should run its dispose animation
}

export enum DiceOperations {
  Sum,
  Min,
  Max,
}
